import {
  Datagrid,
  Filter,
  FunctionField,
  Record,
  SelectInput,
  TextField,
} from "react-admin";
import { ActionsField } from "../../common/data-grid-fields/ActionsField";
import { ProLogsEmpty } from "../../common/list/ProLogsEmpty";
import { IResourceListProps } from "../../common/ra-types";
import { DefaultProLogsList } from "../../common/list/DefaultProLogsList";
import redirectedApiClients from "../../master/redirected-api-clients";
import {
  PublicApiRedirectionListDto,
  PublicApiRedirectionStatus,
} from "../../../common/data/service-proxies";
import RedirectedApiClientsStatusLabel from "../../master/redirected-api-clients/RedirectedApiClientsStatusLabel";
import { ApproveRedirectedApiMenuItem } from "../../master/redirected-api-clients/ApproveRedirectedApiMenuItem";
import { ThumbDown, ThumbUp } from "@material-ui/icons";
import { useTheme } from "@material-ui/core/styles";
import { RejectRedirectedApiMenuItem } from "../../master/redirected-api-clients/RejectRedirectedApiMenuItem";
import permissionNames from "../../../common/auth/access-control/permissionNames";
import { useActionPermissions } from "../../../common/auth/useActionPermissions";

interface Props extends IResourceListProps { }

const ListFilter = (props: any) => {
  return (
    <Filter {...props}>
      <SelectInput
        className="filter-box"
        label="resources.public-api-redirection.labels.filterByStatus"
        allowEmpty
        source="status"
        alwaysOn
        choices={[
          {
            id: PublicApiRedirectionStatus.Active,
            name: "resources.public-api-redirection.labels.active",
          },
          {
            id: PublicApiRedirectionStatus.Pending,
            name: "resources.public-api-redirection.labels.pending",
          },
        ]}
      />
    </Filter>
  );
};

export const RedirectedApiClientsList = (props: Props) => {
  const theme = useTheme();

  const permissions = useActionPermissions();
  const hasRedirectedRequestsPermission = !!(
    permissions &&
    permissions[permissionNames.admin.tenantRegistrations.manage]
  );

  return (
    <div className="content-container">
      <DefaultProLogsList
        empty={<ProLogsEmpty iconType={redirectedApiClients.icon} />}
        className="content-list"
        title="resources.public-api-redirection.name"
        bulkActionButtons={false}
        pagination={false}
        filters={<ListFilter />}
        {...props}
      >
        <Datagrid>
          <FunctionField<PublicApiRedirectionListDto & Record>
            source="authorityUrl"
            label="resources.public-api-redirection.labels.provider"
            render={(record) => {
              if (!record || !record.authorityUrl) return "-";
              const dotIndex = record.authorityUrl.indexOf(".");
              return dotIndex !== -1
                ? record.authorityUrl.substring(dotIndex + 1)
                : record.authorityUrl;
            }}
          />

          <TextField
            source="tenantName"
            label="resources.public-api-redirection.labels.tenant"
          />

          <FunctionField<PublicApiRedirectionListDto & Record>
            source="status"
            label="resources.public-api-redirection.labels.status"
            render={(record) => {
              if (!record || !record.status) return "-";
              return <RedirectedApiClientsStatusLabel status={record.status} />;
            }}
          />

          <ActionsField
            canActivateOrDeactivate={() => false}

          >
            <ApproveRedirectedApiMenuItem
              hidden={(record: PublicApiRedirectionListDto & Record) =>
                record.status === PublicApiRedirectionStatus.Active || !hasRedirectedRequestsPermission
              }
              label="resources.public-api-redirection.labels.approve"
              icon={<ThumbUp style={{ color: theme.palette.success.main }} />}
            />
            <RejectRedirectedApiMenuItem
              hidden={(record: PublicApiRedirectionListDto & Record) =>
                record.status === PublicApiRedirectionStatus.Active || !hasRedirectedRequestsPermission
              }
              label="resources.public-api-redirection.labels.reject"
              icon={<ThumbDown style={{ color: theme.palette.error.main }} />}
            />
          </ActionsField>
        </Datagrid>
      </DefaultProLogsList>
    </div>
  );
};
